import script from "./HrToolbarBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./HrToolbarBtn.vue?vue&type=script&setup=true&lang=js"

import "./HrToolbarBtn.vue?vue&type=style&index=0&id=d848a728&lang=scss"

const __exports__ = script;

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon});
